<i18n>
{
    "de": {
        "produkte": "Produkte",
        "montageart": "Montageart",
        "farben": "Farben",
        "leuchtmittel": "Leuchtmittel",
        "farbtemperatur": "Farbtemperatur",
        "dimmung": "Dimmung",
        "einbautiefe": "Einbautiefe",
        "ausschnittmaß": "Ausschnittmaß",
        "hinweis": "Keine Produkte vorhanden. Bitte überprüfen Sie die ausgewählten Filter oder laden Sie die Seite neu.",
        "montageartLabel": "titel"
    },
    "en": {
        "produkte": "Products",
        "montageart": "Mounting",
        "farben": "Colours",
        "leuchtmittel": "Lamp",
        "farbtemperatur": "Colour Temperature",
        "dimmung": "Dimming",
        "einbautiefe": "Mounting Depth",
        "ausschnittmaß": "Cut Out",
        "hinweis": "No products found. Please check the selected filters or reload the page.",
        "montageartLabel": "titel_en"
    }
}
</i18n>

<template>
  <div class="c-home">
    <div class="container-fluid">
      <div class="row align-items-end mb-5">
        <div
          class="col-auto d-flex flex-column flex-md-row align-items-md-center"
          style="gap: 26px;"
        >
          <h1 class="m-0">{{ $t("produkte") }}</h1>
          <a :href="root + $t('neuheiten_link')">
            <div
              class="c-badge d-inline-block u-text-left px-4 py-2"
              style="position: static; padding: 6px;"
            >
              <img :src="root + 'resources/img/star.svg'" />
              <span style="font-size: 17px;">{{ $t("neuheiten") }}</span>
            </div>
          </a>
        </div>
        <div class="col-24 col-sm u-text-sm-right">
          <div class="row justify-content-end">
            <div
              class="col-24 col-sm-24 col-md-16 col-lg-12 col-xxl-6 mt-4"
              v-if="categories.length > 0"
            >
              <!-- <a :href="root + $t('neuheiten_link')">
                <div
                  class="c-badge d-inline-block d-sm-block u-text-left px-3"
                  style="position: static; padding: 6px;"
                >
                  <img :src="root + 'resources/img/star.svg'" />
                  <span>{{ $t("neuheiten") }}</span>
                </div>
              </a> -->
              <!-- <a class="c-button" :href="root + $t('neuheiten_link')">
                <img
                  class="d-inline"
                  width="12"
                  :src="root + 'resources/img/star.svg'"
                />
                &nbsp;
                <span>{{ $t("neuheiten") }}</span>
              </a> -->
            </div>
          </div>
          <div v-if="params !== ''" class="mt-2">
            <a href="#" @click.prevent="resetFilter"
              >Alle Filter zurücksetzen</a
            >
          </div>
        </div>
      </div>
      <loader v-if="isLoading" />
      <div v-else>
        <div class="d-sm-none">
          <div class="u-border-t"></div>
          <div class="c-collapsible mb-4">
            <div class="c-collapsible__button">
              Filter
            </div>
            <div class="c-collapsible__content">
              <div class="my-3">
                <multiselect
                  :title="$t('montageart')"
                  v-model="filter.categories"
                  :options="categories"
                  :label="$t('montageartLabel')"
                  :label_en="$t('montageartLabel')"
                  trackBy="id"
                />
                <multiselect
                  title="Indoor / Outdoor"
                  v-model="filter.area"
                  :options="area"
                  label="bezeichnung"
                  label_en="bezeichnung_en"
                  trackBy="id"
                />
                <multiselect
                  :title="$t('farben')"
                  v-model="filter.colors"
                  :options="colors"
                  label="bezeichnung"
                  label_en="bezeichnung_en"
                  trackBy="id"
                />
                <multiselect
                  :title="$t('leuchtmittel')"
                  v-model="filter.lamp"
                  :options="lamp"
                  label="bezeichnung"
                  label_en="bezeichnung_en"
                  trackBy="id"
                />
                <multiselect
                  :title="$t('farbtemperatur')"
                  v-model="filter.colortemps"
                  :options="colortemps"
                  label="bezeichnung"
                  label_en="bezeichnung_en"
                  trackBy="id"
                />
                <multiselect
                  :title="$t('dimmung')"
                  v-model="filter.dim"
                  :options="dim"
                  label="bezeichnung"
                  label_en="bezeichnung_en"
                  trackBy="id"
                />
                <multiselect
                  :title="$t('einbautiefe')"
                  v-model="filter.depth"
                  :options="depth"
                  label="bezeichnung"
                  label_en="bezeichnung_en"
                  trackBy="id"
                />
                <multiselect
                  :title="$t('ausschnittmaß')"
                  v-model="filter.cutout"
                  :options="cutout"
                  label="bezeichnung"
                  label_en="bezeichnung_en"
                  trackBy="id"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3 d-none d-sm-flex u-sticky-filter">
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="categories.length > 0"
          >
            <multiselect
              :title="$t('montageart')"
              v-model="filter.categories"
              :options="categories"
              label="titel"
              label_en="titel_en"
              trackBy="id"
            />
          </div>
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="area.length > 0"
          >
            <multiselect
              title="Indoor / Outdoor"
              v-model="filter.area"
              :options="area"
              label="bezeichnung"
              label_en="bezeichnung_en"
              trackBy="id"
            />
          </div>
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="colors.length > 0"
          >
            <multiselect
              :title="$t('farben')"
              v-model="filter.colors"
              :options="colors"
              label="bezeichnung"
              label_en="bezeichnung_en"
              trackBy="id"
            />
          </div>
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="lamp.length > 0"
          >
            <multiselect
              :title="$t('leuchtmittel')"
              v-model="filter.lamp"
              :options="lamp"
              label="bezeichnung"
              label_en="bezeichnung_en"
              trackBy="id"
            />
          </div>
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="colortemps.length > 0"
          >
            <multiselect
              :title="$t('farbtemperatur')"
              v-model="filter.colortemps"
              :options="colortemps"
              label="bezeichnung"
              label_en="bezeichnung_en"
              trackBy="id"
            />
          </div>
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="dim.length > 0"
          >
            <multiselect
              :title="$t('dimmung')"
              v-model="filter.dim"
              :options="dim"
              label="bezeichnung"
              label_en="bezeichnung_en"
              trackBy="id"
            />
          </div>
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="depth.length > 0"
          >
            <multiselect
              :title="$t('einbautiefe')"
              v-model="filter.depth"
              :options="depth"
              label="bezeichnung"
              label_en="bezeichnung_en"
              trackBy="id"
            />
          </div>
          <div
            class="col-24 col-sm-12 col-md-8 col-lg-6 col-xxl"
            v-if="cutout.length > 0"
          >
            <multiselect
              :title="$t('ausschnittmaß')"
              v-model="filter.cutout"
              :options="cutout"
              label="bezeichnung"
              label_en="bezeichnung_en"
              trackBy="id"
            />
          </div>
        </div>
        <div v-if="filteredCategories.length === 0" class="my-5">
          {{ $t("hinweis") }}
        </div>
        <template v-else>
          <div v-for="category in filteredCategories" :key="category.id">
            <h2 class="h3" v-if="lang === 'en'">
              {{ category.titel_en }}
            </h2>
            <h2 class="h3" v-else>{{ category.titel }}</h2>
            <!-- <div class="row gutters-small mb-4"> -->
            <div class="c-grid mb-5">
              <template v-for="productId in category.products">
                <!-- <div
                                class="col-12 col-sm-6 col-lg"
                                :key="productId"
                                @click="
                                    $router.push({
                                        name: 'Produkt',
                                        params: {
                                            art: category.titel,
                                            id: productId,
                                        },
                                    })
                                "
                            > -->
                <div :key="productId" v-if="products[productId]">
                  <router-link
                    :to="
                      '/' +
                        window.toSlug(
                          lang === 'en' ? category.titel_en : category.titel
                        ) +
                        '/' +
                        window.toSlug(products[productId].attributes.titel)
                    "
                  >
                    <div class="c-product">
                      <div
                        class="c-product__thumbwrapper"
                        :class="{ '-ground': category.id == '9' }"
                      >
                        <img
                          class="c-product__thumb"
                          :alt="
                            products[productId].attributes.titel +
                              ' | ' +
                              category.titel +
                              ' - Thumbnail'
                          "
                          v-lazy="getProductThumbnail(productId)"
                        />
                      </div>
                      <div
                        class="c-badge"
                        v-if="products[productId].attributes.new === 1"
                      >
                        <img :src="root + 'resources/img/star.svg'" />
                        <span class="d-none d-xl-inline">{{
                          $t("neuheit")
                        }}</span>
                        <span class="d-inline d-xl-none">{{
                          $t("neuheit_mobil")
                        }}</span>
                      </div>
                      <div
                        class="c-badge"
                        v-if="products[productId].attributes.coming_soon === 1"
                      >
                        <img :src="root + 'resources/img/star.svg'" />
                        <span class="d-none d-xl-inline">{{
                          $t("coming_soon")
                        }}</span>
                      </div>
                      <div class="c-product__title">
                        {{ products[productId].attributes.titel }}
                      </div>
                    </div>
                  </router-link>
                </div>
                <!-- <div
                                class="u-w-full d-none d-lg-block"
                                :key="'divider' + index"
                                v-if="(index + 1) % 5 === 0"
                            ></div> -->
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "@/components/Multiselect";
import Loader from "@/components/LoaderStar";

console.log("Produkte");

export default {
  metaInfo() {
    return {
      title: this.headTitle,
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            this.lang === "en"
              ? ""
              : "Die Kollektion von DLS-Lighting mit einer Auswahl an Leuchten verschiedenster Art welche der Vielzahl von Anforderungen des Lichtplaners entsprechen und für jede Architektur die passende Lichtstimmung schaffen.",
        },
      ],
    };
  },
  components: { Multiselect, Loader },
  props: {
    art: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      imageurl: process.env.VUE_APP_ROOT + "media/",
      filter: {
        categories: [],
        colors: [],
        lamp: [],
        colortemps: [],
        dim: [],
        area: [],
        depth: [],
        cutout: [],
      },
      root: process.env.VUE_APP_ROOT,
      isLoading: false,
      params: "",
      window: window,
    };
  },
  watch: {
    filter: {
      handler: function() {
        var self = this;
        this.params = "";
        for (var key in this.filter) {
          if (
            this.filter[key].length > 0 &&
            !(key === "categories" && this.art)
          ) {
            if (this.params !== "") {
              this.params += "&";
            } else {
              this.params += "?";
            }
            this.filter[key].forEach(function(item, index) {
              self.params += key + "=" + item.id;
              if (self.filter[key].length - 1 > index) {
                self.params += "&";
              }
            });
          }
        }
        var url = this.getCurrentUrl();
        history.pushState({ path: url }, "", url);
      },
      deep: true,
    },
  },
  mounted() {
    // console.log(this.$route);
    if (
      Object.keys(this.categories).length === 0 ||
      Object.keys(this.products).length === 0
    ) {
      this.isLoading = true;
    }

    const getCategories = this.$store.dispatch("getCategories");
    const getProducts = this.$store.dispatch("getProducts");

    Promise.all([getCategories, getProducts]).then(() => {
      this.isLoading = false;
    });

    const getColors = this.$store.dispatch("getColors");
    const getLamp = this.$store.dispatch("getLamp");
    const getColortemps = this.$store.dispatch("getColortemps");
    const getDim = this.$store.dispatch("getDim");
    const getArea = this.$store.dispatch("getArea");
    const getDepth = this.$store.dispatch("getDepth");
    const getCutout = this.$store.dispatch("getCutout");

    Promise.all([
      getCategories,
      getColors,
      getLamp,
      getColortemps,
      getDim,
      getArea,
      getDepth,
      getCutout,
    ]).then(() => {
      for (const filterKey in this.filter) {
        // console.log(filterKey);
        let filterArray = [];
        if (filterKey === "categories" && this.art) {
          let filteredCategory = null;
          if (this.lang === "en") {
            filteredCategory = this[filterKey].find(
              (obj) => window.toSlug(obj.titel_en) === this.art
            );
          } else {
            filteredCategory = this[filterKey].find(
              (obj) => window.toSlug(obj.titel) === this.art
            );
          }
          if (filteredCategory) {
            filterArray.push(filteredCategory);
          } // console.log(filterArray);
        } else {
          const query = this.$route.query[filterKey];
          if (query) {
            if (Array.isArray(query)) {
              for (const urlParam of this.$route.query[filterKey]) {
                filterArray.push(
                  this[filterKey].find((obj) => obj.id == urlParam)
                );
              }
            } else {
              filterArray.push(this[filterKey].find((obj) => obj.id == query));
            }
          }
        }
        this.filter[filterKey] = filterArray;
      }
    });
  },
  computed: {
    headTitle() {
      let headTitle = undefined;
      let category = "";
      if (this.art) {
        if (this.lang === "en") {
          category = this.categories.find(
            (obj) => window.toSlug(obj.titel_en) === this.art
          )?.titel_en;
        } else {
          category = this.categories.find(
            (obj) => window.toSlug(obj.titel) === this.art
          )?.titel;
        }
        if (category) {
          headTitle = category + " - DLS Lighting";
        }
        return headTitle;
      }
      return (this.lang === "en" ? "Products" : "Produkte") + " - DLS Lighting";
    },
    ...mapState([
      "categories",
      "products",
      "colors",
      "lamp",
      "colortemps",
      "dim",
      "area",
      "depth",
      "cutout",
      "lang",
    ]),
    filteredCategories() {
      let result = [];
      // Filter Mapping auf flache Arrays mit Ids
      const selectedColorIds = this.filter.colors.map((obj) => {
        return obj.id;
      });
      const selectedLampIds = this.filter.lamp.map((obj) => {
        return obj.id;
      });
      const selectedColortempIds = this.filter.colortemps.map((obj) => {
        return obj.id;
      });
      const selectedDimIds = this.filter.dim.map((obj) => {
        return obj.id;
      });
      const selectedAreaIds = this.filter.area.map((obj) => {
        return obj.id;
      });
      const selectedDepthIds = this.filter.depth.map((obj) => {
        return obj.id;
      });
      const selectedCutoutIds = this.filter.cutout.map((obj) => {
        return obj.id;
      });

      if (
        this.filter.categories.length === 0 &&
        selectedColorIds.length === 0 &&
        selectedLampIds.length === 0 &&
        selectedColortempIds.length === 0 &&
        selectedDimIds.length === 0 &&
        selectedAreaIds.length === 0 &&
        selectedDepthIds.length === 0 &&
        selectedCutoutIds.length === 0
      ) {
        result = this.categories;
      } else {
        for (let category of this.categories) {
          let filteredCategory = { ...category };
          // Filter Kategorien
          let hasCategory = false;
          if (this.filter.categories.length > 0) {
            for (let selectedCategory of this.filter.categories) {
              if (category.id == selectedCategory.id) {
                hasCategory = true;
                break;
              }
            }
          } else {
            hasCategory = true;
          }
          let filteredProducts = [];
          for (const productId of category.products) {
            // Filter Farben
            const hasColor = this.checkFilter(
              productId,
              selectedColorIds,
              "farben"
            );
            // Filter Leuchtmittel
            const hasLamp = this.checkFilter(
              productId,
              selectedLampIds,
              "leuchtmittel"
            );
            // Filter Farbtemperatur
            const hasColortemp = this.checkFilter(
              productId,
              selectedColortempIds,
              "farbtemperatur"
            );
            // Filter Dimmung
            const hasDim = this.checkFilter(
              productId,
              selectedDimIds,
              "dimmung"
            );
            // Filter Indoor / Outdoor
            const hasArea = this.checkFilter(
              productId,
              selectedAreaIds,
              "area"
            );
            // Filter Einbautiefe
            const hasDepth = this.checkFilter(
              productId,
              selectedDepthIds,
              "einbautiefe"
            );
            // Filter Ausschnittmaß
            const hasCutout = this.checkFilter(
              productId,
              selectedCutoutIds,
              "ausschnitt_mass"
            );
            if (
              hasColor &&
              hasLamp &&
              hasColortemp &&
              hasDim &&
              hasArea &&
              hasDepth &&
              hasCutout
            ) {
              filteredProducts.push(productId);
            }
          }
          if (hasCategory && filteredProducts.length > 0) {
            filteredCategory.products = filteredProducts;
            result.push(filteredCategory);
          }
        }
      }
      return result;
    },
  },
  methods: {
    getProductThumbnail(productId) {
      let result = "";
      if (
        this.products[productId].attributes
          .produktbild_transparent_thumbnail === 1
      ) {
        result =
          process.env.VUE_APP_ROOT +
          "index.php?rex_media_type=product_thumbnail&rex_media_file=" +
          this.products[productId].attributes.produktbild_transparent;
      } else {
        result = this.imageurl + this.products[productId].attributes.thumbnail;
      }
      return result;
    },
    resetFilter() {
      for (const filterKey in this.filter) {
        this.filter[filterKey] = [];
      }
    },
    getCurrentUrl: function() {
      var url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "" +
        this.params;
      // var currentScrollPosition = document.documentElement.scrollTop;
      // if (this.params !== "") {
      //     url += "&position=" + currentScrollPosition;
      // } else {
      //     url += "?position=" + currentScrollPosition;
      // }
      return url;
    },
    checkFilter(productId, selectedFilterIds, relationshipName) {
      let hasFilter = false;
      // console.log(productId);
      if (selectedFilterIds.length > 0) {
        if (relationshipName === "ausschnitt_mass") {
          for (const selectedFilter of this.filter.cutout) {
            const productCutout = parseInt(
              this.products[productId].attributes.ausschnitt_mass
            );
            const min = parseInt(selectedFilter.min);
            const max = parseInt(selectedFilter.max);
            // if (!isNaN(min) && !isNaN(max) && min !== max) {
            //   min--;
            //   max++;
            // }
            if (
              !isNaN(productCutout) &&
              (((isNaN(min) || min <= productCutout) &&
                (isNaN(max) || productCutout <= max)) ||
                (min === productCutout && productCutout === max))
            ) {
              // console.log("min", min);
              // console.log("ausschnitt_mass", productCutout);
              // console.log("max", max);
              hasFilter = true;
              break;
            }
          }
        } else {
          // console.log(productId);
          const productFilterIds = this.products[productId].relationships[
            relationshipName
          ].data.map((obj) => {
            return obj.id;
          });

          if (
            selectedFilterIds.some((color) => productFilterIds.includes(color))
          ) {
            hasFilter = true;
          }
        }
      } else {
        hasFilter = true;
      }
      return hasFilter;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.c-home {
  .container-fluid {
    padding-right: 3vw;
    padding-left: 3vw;
  }
  .c-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;

    @include media-breakpoint-down(lg) {
      grid-template-columns: repeat(4, 1fr);
    }
    @include media-breakpoint-down(md) {
      grid-template-columns: repeat(3, 1fr);
    }
    @include media-breakpoint-down(xs) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  // .gutters-small {
  //     margin-left: -7px;
  //     margin-right: -7px;
  //     [class*="col"] {
  //         padding-left: 7px;
  //         padding-right: 7px;
  //     }
  // }
  .c-product {
    cursor: pointer;
    position: relative;
    &__thumbwrapper {
      background: linear-gradient(#929292, #f2f2f2);

      &.-ground {
        background: linear-gradient(#f2f2f2, #929292);
      }
    }
    &__thumb {
      width: 100%;
    }
    &__title {
      margin-top: 10px;
      margin-bottom: 25px;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
.u-sticky-filter {
  position: sticky;
  top: 0;
  background: white;
  z-index: 998;
}
</style>
